import { render } from "./DetailFooterView.vue?vue&type=template&id=87b0bcb2&scoped=true&ts=true"
import script from "./DetailFooterView.vue?vue&type=script&lang=ts"
export * from "./DetailFooterView.vue?vue&type=script&lang=ts"

import "./DetailFooterView.vue?vue&type=style&index=0&id=87b0bcb2&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b0bcb2"]])

export default __exports__